$('.services__more').click(function(event){
	let self = $(this);
	let services = self.parents('.services');
	self.slideUp(0);
	services.find('.services__list__hidden').stop().slideDown('slow');
	event.preventDefault();
});
